import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  #installmentsCtaWired = false;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    // Deixa essa parte fora do clique para não pesar na abertura do carrinho
    this.#setupInstallmentsClose();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.open();
    }
  };

  open() {
    // Abre imediatamente
    this.showDialog();

    // Garante o listener, mas sem travar o clique
    this.#setupInstallmentsClose();
  }

  close() {
    this.closeDialog();
  }

  #setupInstallmentsClose() {
    if (this.#installmentsCtaWired) return;

    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');

      if (!cta) return;

      cta.addEventListener('click', () => {
        this.close();
      });

      this.#installmentsCtaWired = true;
    }).catch(() => {
      // Evita erro silencioso quebrar o drawer
    });
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}